// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary

export function minifyGraphQLQuery(query: string): string {
  // Remove line breaks, tabs, and multiple spaces
  return query.replace(/\s+/g, " ").trim();
}
